import { useCallback, useContext } from 'react';
import { InfoDialogContext } from './infoDialogContext';
export const useShowInfoDialog = () => {
    const { setProps, setOpen } = useContext(InfoDialogContext);
    const wrapper = useCallback((props) => {
        setOpen(true);
        setProps({ ...props });
    }, [setProps, setOpen]);
    return wrapper;
};
//# sourceMappingURL=useShowInfoDialog.js.map